<template lang="pug">
    .settings(v-if='settings')
        template
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
                | {{ settings.difficult.amountOfRows + ' x ' + settings.difficult.amountOfColumns }}
            br
            template(v-if='settings.numbers.length > 0')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}: {{ settings.numbers.join(', ') }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}: {{ operations }}
            br
        br
        slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { camelCase } from 'lodash';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        computed: {
            operations() {
                const fields = [];
                for (let key in this.settings.operations) {
                    this.settings.operations[key] && fields.push(key);
                }
                return fields
                    .map(field => this.$i18n.t(`trainer.trainer_gameFormSetting_operation${this.pascalCase(field)}`))
                    .join(', ');
            },
        },
        methods: {
            pascalCase(word) {
                word = camelCase(word);
                return word.charAt(0).toUpperCase() + word.slice(1);
            },
        },
    };
</script>
